import styled from "styled-components";

export const PlayerWrapper = styled.div`
  .cld-video-player.video-js.vjs-fill:not(.vjs-audio-only-mode) {
    width: auto;
  }

  .vjs-menu-content {
    right: 2rem;
  }
  video.vjs-tech {
    position: initial;
  }
`;
